module.exports = __webpack_public_path__ + "img/08.2aa4cbcd.jpg";